<template>
  <div>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <b-col cols="4" class="ta-left">
              <b-form-group description="Search Keyword">
                <form class="d-flex">
                  <b-input-group>
                    <b-input-group-prepend>
                      <b-input-group-text class="custom-search-icon">
                        <i class="bx bx-search-alt-2"></i>
                      </b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input
                      class="rounded-0 custom-input"
                      v-model="filter"
                      type="search"
                      placeholder="Search here..."
                    ></b-form-input>
                  </b-input-group>
                </form>
              </b-form-group>
            </b-col>
          </div>
        </div>
        <div class="card">
          <div class="card-body">
            <b-row>
              <b-col sm class="mt-2 mb-2">
                <div class="align-self-center">
                  <span class="fw-bold ms-2">
                    <label class="fs-5">All Users</label>
                    <b-badge pill class="cstm-badge fs-6">{{
                      this.usersTotalRows
                    }}</b-badge>
                  </span>
                </div>
              </b-col>
              <b-col sm class="mt-2 mb-2">
                <div
                  v-if="access.create"
                  class="d-flex flex-wrap align-items-center justify-content-md-end mt-md-0 gap-2"
                >
                  <a
                    href="javascript:void(0);"
                    class="btn btn-primary"
                    data-bs-toggle="modal"
                    @click="addUser()"
                    ><i class="uil uil-plus me-1"></i>Add User</a
                  >
                </div>
              </b-col>
            </b-row>

            <div class="table-responsive mt-3">
              <div class="table align-middle table-nowrap">
                <b-table
                  :busy="isLoading"
                  :items="users"
                  :fields="fields"
                  responsive="sm"
                  :current-page="currentPage"
                  :per-page="perPage"
                  class="table-check"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                  @filtered="onFiltered"
                > 
                  <template #table-busy>
                    <div class="text-center text-primary my-2">
                      <b-spinner class="align-middle me-2"></b-spinner>
                      <strong>Loading...</strong>
                    </div>
                  </template>
                  <template #cell(action)="data">
                    <button
                      id="show-btn"
                      type="button"
                      class="btn btn btn-sm btn-danger btn-secondary"
                      @click="deleteUser(data.item)"
                    >
                      <i class="bx bx-trash bx-xs bx-fw"></i>
                    </button>
                  </template>

                  <template #cell(name)="data">
                    <b-link class="fw-medium" @click="editUser(data.item)">
                      {{ data.item.name }}
                      <i class="bx bxs-pencil bx-xs bx-fw"></i>
                    </b-link>
                  </template>

                  <template #cell(role)="data">
                    <p class="text-body m-0">{{ data.item.role }}</p>
                  </template>

                  <template #cell(status)="data">
                    <div class="form-check form-switch form-switch-md d-inline">
                      <input
                        v-model="data.item.isActive"
                        type="checkbox"
                        id="flexSwitchCheckChecked"
                        class="form-check-input float-none"
                        block
                        v-b-toggle.accordion-2
                        @change="updateUserStatus(data.item)"
                      />
                    </div>
                  </template>

                  <template #cell(activity)="data">
                    <div>
                      <p class="small" style="margin-bottom: 0">
                        {{
                          data.item.updatedBy == null ||
                          data.item.updatedBy == ""
                            ? "Created by:"
                            : "Modified by:"
                        }}
                      </p>
                      <p class="small" style="margin-bottom: 0">
                        <span class="fw-bold">{{
                          data.item.updatedBy == null ||
                          data.item.updatedBy == ""
                            ? data.item.createdBy
                            : data.item.updatedBy
                        }}</span>
                      </p>
                    </div>
                  </template>
                </b-table>
              </div>
            </div>
            <div class="row g-0 text-center" v-if="usersTotalRows == 0">
              <span>No data to display.</span>
            </div>
            <!-- end table responsive -->

            <!-- </div> -->
            <div class="row g-0 text-center text-sm-start">
              <div class="col-sm-12">
                <div class="row">
                  <div class="col">
                    <label class="col-form-label d-inline-block me-4"
                      >Display:</label
                    >
                    <div class="d-inline-block">
                      <b-form-group label-for="display-record">
                        <b-form-select
                          class="form-select shadow-none w-fit"
                          id="display-record"
                          v-model="perPage"
                          :options="pageOptions"
                        ></b-form-select>
                      </b-form-group>
                    </div>
                    <!-- <div class="form-group row pull-left">
                    </div> -->
                  </div>
                  <div class="col">
                    <div
                      class="dataTables_paginate paging_simple_numbers float-end"
                      v-if="usersTotalRows > perPage"
                    >
                      <!-- pagination -->
                      <b-pagination
                        class="pagination-rounded"
                        v-model="currentPage"
                        :total-rows="usersTotalRows"
                        :per-page="perPage"
                        limit="1"
                        first-number
                        last-number
                      ></b-pagination>
                    </div>
                  </div>
                </div>
              </div>
              <!-- end row -->
            </div>
          </div>
          <!-- end card body -->
        </div>
        <!-- end card -->
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
    <!-- <toast 
      :type="toastType" 
      v-if="showToast" 
      @close="() => showToast = false" 
      :title="toastTitle" 
      :message="toastMessage"/> -->
  </div>
</template>

<script>
import Swal from "sweetalert2";
import appConfig from "@/app.config";
import { usersMethods, usersComputed, layoutMethods, layoutComputed } from "@/state/helpers";
import { getModuleAccess } from '@/helpers/helper.js'

/**
 * Users list component
 */
export default {
  page: {
    title: "User",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  data() {
    return {
      // title: "User",
      isLoading: false,
      users: [],
      totalRows: 0,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50],
      filter: null,
      filterOn: ["name", "role"],
      sortBy: "id",
      sortDesc: false,
      fields: [
        {
          key: "name",
          label: "Name",
          sortable: true,
          tdClass: "align-middle",
        },
        {
          key: "role",
          sortable: true,
          tdClass: "align-middle",
        },
        {
          key: "status",
          sortable: false,
          tdClass: "align-middle",
        },
        {
          key: "activity",
          sortable: false,
          tdClass: "align-middle",
        },
        {
          key: "action",
          sortable: false,
          tdClass: "align-middle",
        }
      ],
      submitted: false,
      access: {
        create: true,
        read: true,
        update: true,
        delete: true,
      },
      usersTotalRows: 0,
      toastTitle: "",
      toastMessage: "",
      toastType: "",
      showToast: false
    };
  },
  computed: {
    ...usersComputed,
    ...layoutComputed
  },
  async mounted() {
    // Set the initial number of items
    // this.totalRows = this.rolesListTotalRows;
    // this.changeTitle({ title: "Users" });
    this.changeBreadCrumb({
      breadCrumbs: [
        { text: "User Management", to: {} },
        { text: 'Users', to: { name: 'users'} }
      ],
    });
    this.changeBackButton({
      value: false
    })
    await this.getUsers();

    // get the module access for checking if user has create, read, update, and/or delete access
    await getModuleAccess("User Management", "Users")
      .then((access) => {
        this.access = access
      }
    );
  },
  methods: {
    ...layoutMethods,
    ...usersMethods,
    async getUsers() {
      this.isLoading = true;
      this.getUsersList()
        .then(() => {
          this.isLoading = false;
          this.users = JSON.parse(JSON.stringify(this.usersList))
          this.usersTotalRows = this.usersTotal;
        })
        .catch((error) => {
          this.isLoading = false;
          console.log("error: ", error);
        });
    },
    addUser() {
      if (!this.access.create) {
        this.$toast.showToast('warning', 'Forbidden', 'You are not allowed to do this operation.');
        return
      }
      this.$router.push({ path: "users/add" });
    },
    editUser(item) {
      if (!this.access.read && !this.access.update) {
        this.$toast.showToast('warning', 'Forbidden', 'You are not allowed to do this operation.');
        return
      }
      this.$router.push({ path: `users/edit/${item.id}` });
    },
    async deleteUser(item) {
      if (!this.access.delete) {
        this.$toast.showToast('warning', 'Forbidden', 'You are not allowed to do this operation.');
        return
      }

      Swal.fire({
        title: "Are you sure?",
        text: `Do you really want to delete ${item.name}? This process cannot be undone.`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#F84B04",
        cancelButtonColor: "#E6EAF1",
        confirmButtonText: "Yes",
        cancelButtonText: "No",
      }).then((result) => {
        if (result.isConfirmed) {
          const params = {
            id: item.id,
            username: item.username,
          };

          this.deleteUserItem(params)
            .then(async () => {
              this.$toast.showToast('success', 'Successful', `You deleted ${item.name}.`);
              await this.getUsers();
            })
            .catch((error) => {
              console.log(error);
              this.$toast.showToast('danger', 'Error', 'Unexpected error occurred.');
            });
        } else {
          return;
        }
      });
    },
    async updateUserStatus(item) {
      if (!this.access.update) {
        this.$toast.showToast('warning', 'Forbidden', 'You are not allowed to do this operation.');
        return
      }

      const params = {
        action: 'update-user-status',
        id: item.id,
        isActive: item.isActive ? 1 : 0,
        updatedBy: JSON.parse(localStorage.getItem("userData")).email,
      };
      this.submitUser(params)
        .then(() => {
          let toastValues = {
            type: "success",
            title: "Success",
            message: `You successfully updated ${item.name}'s status.`
          }
          this.$emit('show-toast', toastValues)
        })
        .catch(async (err) => {
          console.log(err);
          this.$toast.showToast('danger', 'Failed', 'Unexpected error occurs. Please try again.');
        });
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.usersTotalRows = filteredItems.length;
      this.currentPage = 1;
    },
  },
};
</script>

<style>
.cstm-badge {
  color: #fff;
  background-color: #0062ff;
  border-radius: 10px;
  margin-left: 10px;
}

.table {
  --bs-table-bg: transparent;
}

.table th {
  background-color: #f5f6f8;
}

.custom-search-icon {
  font-size: 1.5rem;
  background-color: transparent;
  border-right: 0px;
  border-radius: 5px 0px 0px 5px;
}

.custom-input {
  border-left: 0;
  border-radius: 0px 5px 5px 0px !important;
}

.table td {
  width: 400px;
}

.form-check-input {
  border-color: #7e93a059;
}
</style>
